import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined, searchTerm: string | null | undefined): SafeHtml | string {
    if (!value) {
      return '';
    }

    if (!searchTerm || searchTerm.trim() === '') {
      return value;
    }

    // Escape special regex characters in the search term
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    
    // Create a regex that matches the search term case-insensitively
    const regex = new RegExp(escapedSearchTerm, 'gi');
    
    // Replace matches with highlighted version
    const highlightedValue = value.replace(regex, (match) => {
      return `<mark class="highlight-search">${match}</mark>`;
    });

    // Use bypassSecurityTrustHtml since we're controlling the HTML content
    return this.sanitizer.bypassSecurityTrustHtml(highlightedValue);
  }
}
